import {h, Fragment} from "preact"
import { useFacet } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)

    // Create local state to track filter selections
    const [localSelections, setLocalSelections] = useState({})

    // Initialize local selections from facet data
    useEffect(() => {
        const initialSelections = {}
        facet.data?.forEach((item) => {
            initialSelections[item.value] = item.selected
        })
        setLocalSelections(initialSelections)
    }, [facet.data])

    // Handle local filter selection
    const handleFilterChange = (value, isSelected) => {
        setLocalSelections((prev) => ({
            ...prev,
            [value]: isSelected,
        }))

        // Add event listener for when user clicks "View Results"
        const viewResultsButton = document.querySelector('.ns-apply-filters')
        if (viewResultsButton) {
            viewResultsButton.addEventListener('click', () => {
                toggleProductFilter(facet.field, value, isSelected)
            })
        }
    }

    return (
        <accordion-disclosure class="accordion">
            <details class="accordion__disclosure group" aria-expanded="false">
                <summary>
                    <span class="accordion__toggle h6">
                        <span class="text-with-icon gap-4">{facet.name}</span>
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            fill="none"
                            width="10"
                            class="group-expanded:rotate icon icon-chevron-down"
                            viewBox="0 0 10 10">
                            <path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
                        </svg>
                    </span>
                </summary>

                <div class="accordion__content">
                    {facet.name === 'Available' ? (
                        <div class="checkbox-control">
                            <input
                                id={facet.id}
                                type="checkbox"
                                class="switch"
                                checked={localSelections[facet.data[1]?.value] || false}
                                onChange={(e) => {
                                    e.preventDefault()
                                    handleFilterChange(
                                        facet.data[1].value,
                                        !localSelections[facet.data[1].value]
                                    )
                                }}
                            />
                            <label for={facet.id} class="text-subdued">
                                In stock only
                            </label>
                        </div>
                    ) : (
                        <div class="v-stack gap-2.5">
                            {facet.data?.map((value) => (
                                <div class="checkbox-control" key={value.value}>
                                    <input
                                        id={`${facet.id}-${value.value}`}
                                        class="dot-checkbox"
                                        type="checkbox"
                                        name={facet.field}
                                        value={value.value}
                                        checked={localSelections[value.value] || false}
                                        onChange={(e) => {
                                            handleFilterChange(value.value, !localSelections[value.value])
                                        }}
                                    />
                                    <label for={`${facet.id}-${value.value}`}>
                                        {value.value} ({value.count})
                                    </label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </details>
        </accordion-disclosure>
    )
}
